var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { toState } from '../base/redux/functions';
/**
 * Extracts the fqn part from a path, where fqn represents
 * tenant/roomName.
 *
 * @param {Object} state - A redux state.
 * @returns {string}
 */
export function extractFqnFromPath(state) {
    var _a, _b;
    let pathname;
    if (window.location.pathname) {
        pathname = window.location.pathname;
    }
    else if (state === null || state === void 0 ? void 0 : state['features/base/connection']) {
        pathname = (_b = (_a = state['features/base/connection'].locationURL) === null || _a === void 0 ? void 0 : _a.pathname) !== null && _b !== void 0 ? _b : '';
    }
    else {
        return '';
    }
    const parts = pathname.split('/');
    const len = parts.length;
    return parts.length > 2 ? `${parts[len - 2]}/${parts[len - 1]}` : parts[1];
}
/**
 * Returns the url used for fetching dynamic branding.
 *
 * @param {Object | Function} stateful - The redux store, state, or
 * {@code getState} function.
 * @returns {string}
 */
export function getDynamicBrandingUrl(stateful) {
    return __awaiter(this, void 0, void 0, function* () {
        const state = toState(stateful);
        // NB: On web this is dispatched really early, before the config has been stored in the
        // state. Thus, fetch it from the window global.
        const config = navigator.product === 'ReactNative' ? state['features/base/config'] : window.config;
        const { dynamicBrandingUrl } = config;
        if (dynamicBrandingUrl) {
            return dynamicBrandingUrl;
        }
        const { brandingDataUrl: baseUrl } = config;
        const fqn = extractFqnFromPath(state);
        if (baseUrl && fqn) {
            return `${baseUrl}?conferenceFqn=${encodeURIComponent(fqn)}`;
        }
    });
}
/**
 * Selector used for getting the load state of the dynamic branding data.
 *
 * @param {Object} state - Global state of the app.
 * @returns {boolean}
 */
export function isDynamicBrandingDataLoaded(state) {
    return state['features/dynamic-branding'].customizationReady;
}
